import axios from "axios";
import env from "@/env";

export default axios.create({
   baseURL: (env.DevMode ? env.ApiUrl.Dev : env.ApiUrl.Prod) + "/api",
   headers: {
      "Content-Type": "application/json",
   },
});
